import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import {styled} from "@mui/system"
import {
	FormControl,
	InputLabel,
	AppBar,
	Toolbar,
	IconButton,
	Drawer,
	TextField,
	Autocomplete,
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import vistaprintLogo from "./vistaprint.png"
import SideBar from "../sideBar/sideBar"
//import history from "../../utils/history"
import {navigateTo} from "../../utils/navigotor"
import {updateURLParameter, getTenantId} from "../../utils/Routes"
import {TenantsContext} from "../../contexts/TenantsContext"
import TenantService from "../../services/tenant/TenantService"
import {TenantResponse} from "../../dtos/tenantResponse"

const HeaderRoot = styled("header")({
	flexGrow: 1,
})

const Grow = styled("div")({
	flexGrow: 1,
})

const MenuButton = styled(IconButton)({
	marginLeft: -12,
	marginRight: 20,
})

export interface HeadProps {}

function Header(props: HeadProps) {
	const [tenantId, setTenantId] = useState<string>(getTenantId())

	const [tenants, setTenants] = useState<TenantResponse[]>([])
	const [state, setState] = React.useState({
		drawer: false,
	})

	const urlParams = new URLSearchParams(window.location.search)
	const hideHeader =
		urlParams.has("hideheader") && urlParams.get("hideheader") === "true" ? true : false

	const handleTenantChange = (event: any, newValue: string | null) => {
		if (newValue) {
			setTenantId(newValue)

			navigateTo(
				window.location.pathname + updateURLParameter(window.location.search, "tenantId", newValue),
				{replace: true}
			)
		}
	}

	const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
		if (
			event.type === "keydown" &&
			((event as React.KeyboardEvent).key === "Tab" ||
				(event as React.KeyboardEvent).key === "Shift")
		) {
			return
		}

		setState({...state, drawer: open})
	}

	useEffect(() => {
		async function loadTenants() {
			const tenantsvc = new TenantService()
			const tenantsList = await tenantsvc.getTenants()
			setTenants(tenantsList)
		}
		loadTenants()
	}, [])

	return (
		<HeaderRoot>
			{!hideHeader && (
				<AppBar position="static" color="default">
					<TenantsContext.Provider value={{tenants}}>
						<Toolbar variant="dense">
							<MenuButton onClick={toggleDrawer(true)} aria-label="Menu">
								<MenuIcon />
							</MenuButton>
							<Grow>
								<img src={vistaprintLogo} width="auto" height="25" alt="" />
							</Grow>
							<Drawer anchor="left" open={state.drawer} onClose={toggleDrawer(false)}>
								<SideBar handler={toggleDrawer}></SideBar>
							</Drawer>
							{tenants.length > 0 && (
								<FormControl variant="standard" sx={{minWidth: 200}}>
									<InputLabel shrink>Choose a tenant</InputLabel>
									<Autocomplete
										freeSolo
										value={tenantId}
										options={tenants.map((tenant) => tenant.id)}
										filterOptions={(options) => options}
										ListboxProps={{style: {maxHeight: 600, width: "auto"}}}
										onChange={handleTenantChange}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Choose a tenant"
												variant="standard"
												InputLabelProps={{shrink: true}}
												onKeyDown={(event) => {
													if (event.key === "Enter") {
														event.preventDefault()
														const typedTenant = (event.target as HTMLInputElement).value
														if (typedTenant) {
															handleTenantChange(event, typedTenant)
														}
													}
												}}
											/>
										)}
									/>
								</FormControl>
							)}
						</Toolbar>
					</TenantsContext.Provider>
				</AppBar>
			)}
		</HeaderRoot>
	)
}

Header.propTypes = {
	classes: PropTypes.object.isRequired,
} as any

export default Header
